<template>
    <div class="index notranslate">
        <v-header></v-header>

        <!-- cart content -->
        <mu-container class="content" style="padding-left:0px;padding-right:0px;overflow-y:auto;padding-bottom:60px;" >
            <van-steps :active="getActive">
  <van-step>{{$t('orderList.methodAndTime')}}</van-step>
  <van-step>{{$t('orderList.customerInfo')}}</van-step>
  <van-step>{{$t('orderList.confirmOrder')}}</van-step>
</van-steps>
            <!-- <mu-form :model="tableOrderInfo" class="mu-demo-form" label-position="top" style="width:90%;margin:0 auto;margin-top:20px;">
                <mu-form-item :label="$t('orderList.telephone')"  prop="telephone"  :rules="phoneRules" >
                    <mu-text-field v-model="tableOrderInfo.telephone"  @change="getCustomer"></mu-text-field>
                 </mu-form-item>
                <mu-form-item :label="$t('orderList.name')" prop="name" :rules="nameRules">
                    <mu-text-field v-model="tableOrderInfo.name" ></mu-text-field>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.email')" prop="email">
                    <mu-text-field v-model="tableOrderInfo.email"></mu-text-field>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.postNummer')" prop="postNummer" v-if="this.tableOrderInfo.deliveryType==2">
                    <mu-text-field v-model="tableOrderInfo.postNummer"  @change="getZCode"></mu-text-field>
                    <div style="padding-top:10px;color: #da5b3a;">{{$t('orderList.deliveryFee')}} {{tableOrderInfo.postAmount}} {{seller.unit}}</div>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.postBy')" prop="postBy" v-if="this.tableOrderInfo.deliveryType==2">
                    <mu-text-field v-model="tableOrderInfo.postBy"></mu-text-field>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.address')" prop="address" v-if="this.tableOrderInfo.deliveryType==2">
                    <mu-text-field v-model="tableOrderInfo.address"></mu-text-field>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.adult')" prop="adult" >
                    <mu-text-field v-model="tableOrderInfo.number" ></mu-text-field>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.children')" prop="children">
                    <mu-text-field v-model="tableOrderInfo.children"></mu-text-field>
                 </mu-form-item>
                 <mu-form-item :label="$t('orderList.specielle')" prop="specielle">
                    <mu-text-field v-model="tableOrderInfo.specielle"></mu-text-field>
                 </mu-form-item>
            </mu-form> -->

            <van-form :model="tableOrderInfo">
  <van-field
    v-model="tableOrderInfo.telephone"
    name="telephone"
    :label="$t('orderList.telephone')"
    :placeholder="$t('orderList.telephone')"
    @change="getCustomer"
    :rules="[{ required: true, message: $t('orderList.telephoneNotNull') }]"
  />
  <van-field
    v-model="tableOrderInfo.name"
    name="name"
    :label="$t('orderList.name')" 
    :placeholder="$t('orderList.name')"
    :rules="[{ required: true, message: $t('orderList.nameNotNull')}]"
  />
  <van-field
    v-model="tableOrderInfo.email"
    name="email"
    :label="$t('orderList.email')" 
    :placeholder="$t('orderList.email')"
    :rules="[{ required: true, message: $t('orderList.emailNotNull')}]"
  />

  <van-field v-if="this.tableOrderInfo.deliveryType==2"
    v-model="tableOrderInfo.postNummer"
    name="postNummer"
    @change="getZCode"
    :label="$t('orderList.postNummer')"
    :placeholder="$t('orderList.postNummer')"
    :rules="[{ required: true, message: $t('orderList.postNummerNotNull')}]"
  />
  <van-field v-if="this.tableOrderInfo.deliveryType==2"
    v-model="tableOrderInfo.postBy"
    name="postBy"
    :label="$t('orderList.postBy')"
    :placeholder="$t('orderList.postBy')"
    :rules="[{ required: true, message: $t('orderList.postByNotNull')}]"
  />

 
  <van-field v-if="this.tableOrderInfo.deliveryType==2"
    v-model="tableOrderInfo.address"
    name="address"
    :label="$t('orderList.address')"
    :placeholder="$t('orderList.address')"
    :rules="[{ required: true, message: $t('orderList.addressNotNull')}]"
  />
  <div v-if="this.tableOrderInfo.deliveryType==2" style="padding:10px;padding-left:110px;color: #da5b3a;">{{$t('orderList.deliveryFee')}} {{tableOrderInfo.postAmount}} {{seller.unit}}</div>
  
<van-field 
    v-model="tableOrderInfo.number"
    type="digit"
    name="adult"
    :label="$t('orderList.adult')"
    :placeholder="$t('orderList.adult')"
    :rules="[{ required: true, message: $t('orderList.numberNotNull')}]"
  />
  <van-field 
    v-model="tableOrderInfo.children"
    type="digit"
    name="children"
    :label="$t('orderList.children')"
    :placeholder="$t('orderList.children')"
  />

  <van-field
  v-model="tableOrderInfo.specielle"
  rows="1"
  autosize
  :label="$t('orderList.specielle')"
   :placeholder="$t('orderList.specielle')"
   type="textarea"
/>
</van-form>
        </mu-container>

        <div class="oprations">
                <div class="oprations-btn">
                    <div class="oprations-back" @click="jumpBack">{{$t('common.back')}}</div>
                </div>
                <div class="oprations-btn">
                    <div class="oprations-next enough" @click="next">{{$t('common.submit')}}</div>
                </div>
            </div>

            <mu-dialog  transition="slide-bottom"  style="overflow: scroll;" :title="$t('common.submit')" :open.sync="openConfirm">
                <div style="padding: 0px;">
                    <mu-form class="mu-demo-form" :model="tableOrderInfo" label-width="90" labelPosition="left">
                        <mu-form-item  :label="$t('orderList.name')" class="form-confirm-item">
                            <div class="form-confirm-txt">{{tableOrderInfo.name}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.telephone')"  class="form-confirm-item">
                            <div class="form-confirm-txt">{{tableOrderInfo.telephone}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.orderTime')"  class="form-confirm-item">
                            <div class="form-confirm-txt">{{tableOrderInfo.orderTime}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.email')"  class="form-confirm-item">
                            <div class="form-confirm-txt">{{tableOrderInfo.email}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.address')" v-if="tableOrderInfo.deliveryType==2"  class="form-confirm-item">
                            <div class="form-confirm-txt">
                                <div> {{tableOrderInfo.postNummer}}  {{tableOrderInfo.postBy}}</div>   
                                <div> {{tableOrderInfo.address}}</div>   
                            </div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.number')"  class="form-confirm-item">
                            <div class="form-confirm-txt">{{$t('orderList.adult')}}:{{tableOrderInfo.number}}   {{ $t('orderList.children') }}:{{tableOrderInfo.children==null?0:tableOrderInfo.children}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.specielle')"  class="form-confirm-item" v-if="tableOrderInfo.specielle!=null&&tableOrderInfo.specielle!=''">
                            <div class="form-confirm-txt">{{tableOrderInfo.specielle}} </div>
                        </mu-form-item>
                    </mu-form>
            
            <mu-list style="max-height: 200px;overflow-y: scroll;">
                <div class="cart-box" v-for="(val, key, index) in cartShowData" :key="index">
                <mu-list>
                    <mu-list-item style="height:36px;">
                        <mu-list-item-content>
                            <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                        </mu-list-item-content>
                    </mu-list-item>
                    <mu-divider></mu-divider>
                    <mu-list-item style="height:50px;margin:10px auto;overflow: hidden;" v-for="item,index in val" :key="index">
                        <mu-flex class="flex-wrapper">
                            <img :src="getImgUrl(item.foodImage,200)" style="border-radius:0;width:60px;height:40px;">
                            <div style="margin-left: 10px;height:40px;width:100%;float:left;">
                                <div style="float:left;">
                                    <div style="font-size:12px;height:12px;line-height:12px;width:100%;">
                                        {{item.foodName}}
                                    </div>
                                    <div style="font-size:12px;height:12px;line-height:12px;width:100%;" v-if="item.decideName!=null && item.decideName!=''">
                                        {{item.decideName}}
                                    </div>
                                    <div >
                                        <span class="now">{{Number(item.quantity * item.price).toFixed(0)}} {{seller.unit}}</span><span v-show="item.foodDiscount!=1" class="old">{{Number(item.quantity * item.price)}}  {{seller.unit}}</span>
                                    </div>
                                </div>
                            
                            </div>
                        </mu-flex>
                    </mu-list-item>
                </mu-list>
                </div>
            </mu-list>
       
            <mu-list>
                <mu-list-item style="height:30px;float:right;" v-if="tableOrderInfo.deliveryType==2">
                    <mu-list-item-content style="font-size:14px;">
                        {{$t('orderList.subAmount')}}:<span style="color:#f01414;font-weight:600;"> {{subAmount}} {{seller.unit}}</span>
                    </mu-list-item-content>
                </mu-list-item>
                <mu-list-item style="height:30px;float:right;" v-if="tableOrderInfo.deliveryType==2">
                    <mu-list-item-content style="font-size:14px;">
                        {{$t('orderList.postAmount')}}:<span style="color:#f01414;font-weight:600;"> {{tableOrderInfo.postAmount}} {{seller.unit}}</span>
                    </mu-list-item-content>
                </mu-list-item>
                <mu-list-item style="height:40px;float:right;margin-bottom:10px;">
                    <mu-list-item-content style="font-size:18px;font-weight:600;">
                        {{$t('orderList.total')}}:<span style="color:#f01414;font-weight:600;"> {{allAmount}} {{seller.unit}}</span>
                    </mu-list-item-content>
                </mu-list-item>
            </mu-list>
            <mu-list>
                <mu-button color="primary" large full-width @click="submitOrder" style="background-color:#da5b3a;width:94%;text-transform: unset;">
                        {{$t('common.submitOrder')}}
                    </mu-button>
            </mu-list>
                </div>
             <div style="background-color:#000;position:absolute;top:0;opacity:0.6;height:100%;z-index:99999;color:#fff;text-align:center;" v-if="isLoading">
                <div v-loading="true" style="vertical-align:central;margin-top:320px;">
                </div>
                <span style="color: #fff;">{{$t('orderList.orderSubmitted')}}</span>
            </div>
            </mu-dialog>
        
    </div>
</template>
<script>
    import header from '../components/TakeawayHeader';
    export default {
        name: 'Cart',
        data() {
            return {
                tableOrderInfo: {},
                seller:{},
                configsData:{},
                openConfirm:false,
                cartList:[],
                cartShowData:{},
                subAmount:0,
                allAmount:0,
                isLoading:false,
                adultShow:false,
            }
        },
        computed: {
            payClass() {
                this.unPayTip = '';
                return false;
            },
            getActive(){
                if(this.openConfirm){
                    return 2;
                }
                return 1;
            },
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.getConfigs();
            this.getCartList();
        },
        methods: {
            validateEmail(email) {
                // 使用正则表达式校验邮箱格式
                const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return reg.test(email);
            },
           
              getConfigs() {
                this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if (response.code == 200) {
                        response.data.forEach((item) => {
                            this.configsData[item.configKey] = item.configValue;
                        })
                        if (this.tableOrderInfo.deliveryType == 2) {
                            if (this.tableOrderInfo.postAmount == undefined || this.tableOrderInfo.postAmount == null) {
                                this.tableOrderInfo.postAmount =parseFloat(this.configsData.DeliveryFee);
                            }
                        }
                        else {
                            this.tableOrderInfo.postAmount = 0;
                        }
                    }
                    });
            },
            getCustomer() {
                this.$get('QRCodeOrder/GetCustomer', { restaurantId: this.tableOrderInfo.restaurantId,customerPhone: this.tableOrderInfo.telephone})
                    .then(response => {
                        if(response.code==200){
                           if(response.data!=null && response.data!=''){
                                this.tableOrderInfo.name=response.data.customerName;
                                this.tableOrderInfo.email=response.data.customerEmail;
                                this.tableOrderInfo.postNummer=response.data.postNo;
                                this.tableOrderInfo.postBy=response.data.postCity;
                                this.tableOrderInfo.address=response.data.postAddress;
                           }
                           else{
                                this.tableOrderInfo.email='';
                                this.tableOrderInfo.postNummer='';
                                this.tableOrderInfo.postBy='';
                                this.tableOrderInfo.address='';
                           }
                           this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo,72000000);
                            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                        }
                    });
            },
            getZCode() {
                this.$get('QRCodeOrder/GetZCode', { restaurantId: this.tableOrderInfo.restaurantId,code:this.tableOrderInfo.postNummer})
                    .then(response => {
                        if(response.code==200){
                            if(response.data!=null && response.data!=''){
                                this.tableOrderInfo.postBy=response.data.name;
                                this.tableOrderInfo.postAmount=response.data.freight;
                            }
                            else{
                                this.tableOrderInfo.postBy='';
                                this.tableOrderInfo.postAmount=parseFloat(this.configsData.DeliveryFee);
                            }
                            if(this.tableOrderInfo.deliveryType==2){
                                 this.allAmount=this.subAmount+this.tableOrderInfo.postAmount;
                            }
                            else{
                                this.allAmount=this.subAmount;
                                this.tableOrderInfo.postAmount=0;
                            }
                            this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo,72000000);
                            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                        }
                    });
            },
            jumpBack() {
                this.$router.go(-1);
            },
            next(){
                if(this.tableOrderInfo.telephone==undefined||this.tableOrderInfo.telephone==null||this.tableOrderInfo.telephone==''){
                    this.$alert(this.$t("orderList.telephoneNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.name==undefined||this.tableOrderInfo.name==null||this.tableOrderInfo.name==''){
                    this.$alert(this.$t("orderList.nameNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.email==undefined||this.tableOrderInfo.email==null||this.tableOrderInfo.email==''){
                    this.$alert(this.$t("orderList.emailNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }     
                if(!this.validateEmail( this.tableOrderInfo.email)){
                    this.$alert(this.$t("orderList.emailError"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.number==undefined||this.tableOrderInfo.number==null||this.tableOrderInfo.number==''){
                    this.$alert(this.$t("orderList.numberNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.deliveryType==2){
                    if(this.tableOrderInfo.postNummer==undefined||this.tableOrderInfo.postNummer==null||this.tableOrderInfo.postNummer==''){
                        this.$alert(this.$t("orderList.postNummerNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                        return;
                    }
                    if(this.tableOrderInfo.postBy==undefined||this.tableOrderInfo.postBy==null||this.tableOrderInfo.postBy==''){
                        this.$alert(this.$t("orderList.postByNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                        return;
                    }
                    if(this.tableOrderInfo.address==undefined||this.tableOrderInfo.address==null||this.tableOrderInfo.address==''){
                        this.$alert(this.$t("orderList.addressNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                        return;
                    }
                }
           
                if(this.tableOrderInfo.postAmount==null){
                    this.tableOrderInfo.postAmount=0;
                }
                this.setItem('sessionStorage', 'tableOrderInfo', this.tableOrderInfo,72000000);
                this.openConfirm=true;
            },
            getCartList() {
                let param = {
                    RestaurantId: this.tableOrderInfo.restaurantId,
                    TableName: this.tableOrderInfo.tableName,
                    Telephone: this.tableOrderInfo.telephone
                };
                this.subAmount =0;
                this.allAmount =0;
                this.$get('QRCodeOrder/GetCartListByPhone', param)
                    .then(response => {
                        if (response.code==200) {
                            this.cartList = response.data;
                            if (this.cartList.length == 0) {
                                this.cartShowData = [];
                            }
                            else {
                                var total = 0;
                                this.cartList.forEach(function (item) {
                                    total += Math.round(item.quantity * item.price);
                                });
                                this.subAmount = total;
                                if(this.tableOrderInfo.deliveryType==2){
                                    this.allAmount =  this.subAmount + parseFloat(this.tableOrderInfo.postAmount);
                                }
                                else{
                                    this.allAmount =  this.subAmount;
                                }
                                this.cartShowData = this.groupBy(this.cartList, (cart) => {
                                    return cart.foodTypeName
                                });
                            }
                        }
                    });
            },
            closeConfirm(){
                this.openConfirm=false;
            },
            submitOrder(){
                if(this.tableOrderInfo.telephone==undefined||this.tableOrderInfo.telephone==null){
                    this.$alert(this.$t("orderList.telephoneNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.telephone==undefined||this.tableOrderInfo.telephone==null){
                    this.$alert(this.$t("orderList.nameNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.deliveryType==2){
                    if(this.tableOrderInfo.postNummer==undefined||this.tableOrderInfo.postNummer==null){
                    this.$alert(this.$t("orderList.postNummerNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.postBy==undefined||this.tableOrderInfo.postBy==null){
                    this.$alert(this.$t("orderList.postByNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.tableOrderInfo.address==undefined||this.tableOrderInfo.address==null){
                    this.$alert(this.$t("orderList.addressNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
            }
                this.$get('QRCodeOrder/GetCartListByPhone', {
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName:this.tableOrderInfo.tableName,
                        Telephone: this.tableOrderInfo.telephone
                    }).then(response => {
                        if (response.code==200) {
                        if(response.data!=null && response.data!=''&& response.data.length>0){
                            this.isLoading = true;
                            let postAmount=0;
                            if(this.tableOrderInfo.deliveryType==2){
                               postAmount=this.tableOrderInfo.postAmount;
                            }
                           let param = {
                            OrderType: 2,
                            RestaurantId: this.tableOrderInfo.restaurantId,
                            TableName: this.tableOrderInfo.tableName,
                            OrderFrom: 3,
                            OrderProcess: 1,
                            DeliveryType: this.tableOrderInfo.deliveryType,
                            OrderDay:  this.tableOrderInfo.orderTime,
                            OrderAmount: 0,
                            OrderDiscount: 1,
                            ActualAmount: 0,
                            PostAmount: postAmount,
                            CouponAmount: 0,
                            Adult: this.tableOrderInfo.number,
                            Child: this.tableOrderInfo.children==null?0:this.tableOrderInfo.children,
                            State: 1,
                            CustomerName: this.tableOrderInfo.name,
                            Telephone: this.tableOrderInfo.telephone,
                            Specielle: this.tableOrderInfo.specielle,
                            Email: this.tableOrderInfo.email,
                            PostNummer: this.tableOrderInfo.postNummer,
                            PostBy: this.tableOrderInfo.postBy,
                            Address: this.tableOrderInfo.address,
                            AccountId: 0,
                            PaymentType: 0,
                            IsInvoice: 0,
                            IsConformed: 0,
                            OrderId: 0,
                            Rabatkode: '',
                            CreateUser: 'user',
                            IsOrderBuffetPackage: 0,
                            IsSendSms: this.tableOrderInfo.isSendSms,
                            IsSeft: 0,
                            }
                            let that=this;
                            this.$post('QRCodeOrder/OrderTakeAwayList', param)
                                .then(response => {
                                    that.isLoading = false;
                                if (response != null) {
                                    if (response.code == 200) {
                                        that.openConfirm=false;
                                        that.tableOrderInfo.date=null;
                                        that.tableOrderInfo.time=null;
                                        that.tableOrderInfo.specielle=null;
                                        that.tableOrderInfo.number=1;
                                        that.tableOrderInfo.postAmount=parseFloat(this.configsData.DeliveryFee);
                                        that.tableOrderInfo.postNummer=null;
                                        that.tableOrderInfo.postBy=null;
                                        that.tableOrderInfo.address=null;
                                        that.setItem('sessionStorage', 'tableOrderInfo', that.tableOrderInfo,72000000);
                                        that.$toast.success(that.$t("common.orderSuccess"));
                                        that.$router.push({
                                            path: '/takeawayOrderList', query: {
                                                orderId:response.data
                                            }
                                        },()=>{},()=>{});
                                    }
                                    else {
                                        that.$alert(this.$t(response.msg), that.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.ok") });
                                    }
                                } else {
                                    that.$alert('The site cannot be accessed, please contact the manager!', 'Alert');
                                }
                            });
                            }
                            else{
                            this.$alert(this.$t("orderList.orderNotNull"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                            return;
                        }
                        }
                       
                    })                        
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            getPath() {
                if (this.$route.path == '/takwawayCustomer') {
                    this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                    this.getConfigs();
                    this.getCartList();
                }
            },
            
        },
        watch: {
            '$route': 'getPath'
        },
        activated() {
            
        },
        components: {
            'v-header': header
        }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-title {
        text-align: center;
    }

    .mu-list {
        padding: 0px;
    }

    .mu-raised-button .mu-button-wrapper {
        padding: 0 12px;
    }

    .mu-button {
        text-transform: unset;
    }

        .mu-button .mu-icon-left {
            margin-right: 3px;
        }

    .material-icons {
        font-size: 12px;
    }

    .content {
        /*  background-image: url(../assets/image/background.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;*/
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .cart-box {
        position: relative;
        margin: auto;
        background-color: #fff;
        background-size: cover;
        overflow-y: unset;
    }

    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }

    .table-info-list-title {
        text-align: center;
        font-size: 14px;
        color: #4fc3f7;
    }

    .cart-opration {
        float: right;
        right: 10px;
        position: absolute;
    }

    .cart-opration-btn {
        width: 36px;
        height: 36px;
        min-width: unset;
        font-size: 16px;
        color: #e53935;
        padding: 0px;
    }

    .cart-opration-quantity {
        width: 36px;
        height: 36px;
        min-width: unset;
        top: -2px;
    }

    .btn-refresh {
        position: fixed;
        right: 10px;
        background-color: #757575 !important;
        z-index: 10;
    }

    .btn-menu {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #757575 !important;
    }

    .btn-continue {
        position: fixed;
        bottom: 10px;
        background-color: #757575 !important;
        left: 41%;
    }

    .btn-refresh {
        position: fixed;
        bottom: 10px;
        left: 10px
    }

    .btn-order {
        position: fixed;
        bottom: 10px;
        right: 10px
    }

    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }

    
    .select {
        background-color: rgb(218, 91, 58);
    }

    .oprations {
        position: fixed;
        bottom: 0;
        right:0;
    }

        .oprations .oprations-btn {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 105px;
            flex: 0 0 105px;
            width: 105px;
            float: left;
        }
            .oprations .oprations-btn .oprations-back {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                background-color: #bdbdbd;
                color: #fff;
                float: right;
                width:100%;
            }

            .oprations .oprations-btn .oprations-next {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                float: right;
                width: 100%;
            }

        .oprations .oprations-btn .oprations-next.not-enough {
            background: #2b333b;
        }

        .oprations .oprations-btn .oprations-next.enough {
            background: #00b43c;
            color: #fff;
        }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }

    .form-confirm-item {
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
    }
    .form-confirm-txt{
        line-height: 26px;
    }

    /deep/ .mu-form-item__label-left, .mu-form-item__label-right{
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        min-height: 22px;
    }
</style>



// WEBPACK FOOTER //
// src/components/TakwawayCustomer.vue